import { Table } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

import styles from './stylesProcessedRequestsTable.module.css';

import CustomPagination from '../../../CommonComponents/CustomPagination/CustomPagination';
import { useWithdrawalReview } from '../WithdrawalReviewContext';
import { convertToUserTimezone } from '../../../../utils/FormatDate';
import UserAvatar from '../../../CommonComponents/UserAvatar/UserAvatar';

function ProcessedRequestsTable() {
  const {
    processedTransactions,
    loadingProcessed,
    handleViewUser,
    openDetailsModal,

    processedPageSize,
    setProcessedPageSize,
    processedCurrentPage,
    setProcessedCurrentPage,
    processedTotalCount,
  } = useWithdrawalReview();

  const getStatusColor = (status) => {
    switch (status) {
      case 'declined':
      case 'cancelled':
        return styles.red;
      default:
        return styles.green;
    }
  };

  const columns = [
    {
      title: 'Request Date',
      dataIndex: 'request_date_timestamp',
      key: 'request_date',
      width: 160,
      render: (text) => <span>{convertToUserTimezone(text)}</span>,
    },
    {
      title: 'Processed Date',
      dataIndex: 'reviewed_at',
      key: 'reviewed_at',
      width: 160,
      render: (text) => <span>{convertToUserTimezone(text)}</span>,
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
      width: 150,
      render: (text, record) => (
        <div className={styles.userImage}>
          <UserAvatar userId={record.user_id} />
          <button onClick={() => handleViewUser(record)}>
            <span>{text}</span>
          </button>
        </div>
      ),
    },
    {
      title: 'Transaction ID',
      dataIndex: 'transaction_id',
      key: 'transaction_id',
      width: 250,
    },
    {
      title: 'Last Deposit Amount',
      dataIndex: 'last_deposit_amount',
      key: 'last_deposit_amount',
      width: 180,
      render: (text, record) => (
        <div className={styles.lastDepositCol}>
          <span>${text}</span>
          <span className={styles.lastDepositColDate}>
            {convertToUserTimezone(record.last_deposit_date, 'MMM DD, HH:mm')}
          </span>
        </div>
      ),
    },
    {
      title: 'Withdrawal Amount',
      dataIndex: 'withdrawal_amount',
      key: 'withdrawal_amount',
      width: 160,
      render: (text) => <span>${text}</span>,
    },
    {
      title: 'Payment Gateway',
      dataIndex: 'payment_gateway',
      key: 'payment_gateway',
      width: 150,
    },
    {
      title: 'Status',
      dataIndex: 'transaction_status',
      key: 'transaction_status',
      width: 140,
      render: (text) => (
        <span className={`${styles.status} ${getStatusColor(text)}`}>
          {text}
        </span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 100,
      fixed: 'right',
      render: (_, record) => (
        <button
          className={styles.actionButton}
          onClick={() => openDetailsModal(record)}
        >
          <EyeOutlined />
        </button>
      ),
    },
  ];

  return (
    <>
      <Table
        loading={loadingProcessed}
        columns={columns}
        dataSource={processedTransactions?.transactions || []}
        pagination={false}
        scroll={{ x: 1500 }}
        rowKey={(record) => record.transaction_id}
        className={styles.customTable}
      />
      <CustomPagination
        total={processedTotalCount || 0}
        pageSize={processedPageSize}
        currentPage={processedCurrentPage}
        onPageSizeChange={(value) => {
          setProcessedPageSize(value);
        }}
        onPageChange={(page) => setProcessedCurrentPage(page)}
      />
    </>
  );
}

export default ProcessedRequestsTable;
